import { render, staticRenderFns } from "./Betting.vue?vue&type=template&id=2a7ef199&"
import script from "./Betting.vue?vue&type=script&lang=js&"
export * from "./Betting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports